var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ra-page--section"},[_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":24}},[_c('auth-x-form',{attrs:{"action":"edit"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }